import { AlertTriangle, RotateCw } from "lucide-react";

export const ErrorState = ({ message, onRetry, testId = "error-state" }) => (
  <div data-testid={testId} className="flex flex-col items-start gap-5 rounded-2xl border border-white/10 bg-[#121212] p-8 md:p-10">
    <div className="flex items-center gap-3 text-[#D4AF37]">
      <AlertTriangle className="h-5 w-5" />
      <span className="eyebrow">Connection hiccup</span>
    </div>
    <p className="max-w-xl text-base text-neutral-300">{message || "We couldn't load the movies right now."}</p>
    <button
      type="button"
      onClick={onRetry}
      data-testid={`${testId}-retry-btn`}
      className="btn-outline-gold inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-medium"
    >
      <RotateCw className="h-4 w-4" /> Retry
    </button>
  </div>
);
